
webpack.register(
    'modules/player-course-collections/player-course-collections',
    function() {
        return import('modules/player-course-collections/player-course-collections');
    },
    true
);